export const onlyNumbers = (value) => {
  return value.replace(/([^\d\s/-])/g, '')
}

export const formatName = (name) => {
  return `${name.split(' ')[0]}  ${name.split(' ').pop()}`
}
